export default "__VITE_ASSET__CtEhKvvy__"